const margin = 8;
const topbarHeight = 60;
const largeTopbarHeight = 115;
const breadCrumbHeight = 48;
const appDrawerWidth = 260;
const appDrawerItemHeight = 45;
const minimumPageWidth = 800;
const maximumPageWidth = 1200;
const minimumPageHeight = 1200;
const homeGridHeight = 400;
// const webshopMainLayoutYPadding = 395;
// const webshopInnerLayoutPadding = ;

export const dimensions = {
  headerFontSize: 14,
  topbarHeight: topbarHeight,
  largeTopbarHeight: largeTopbarHeight,
  breadCrumbHeight: breadCrumbHeight,
  totalTopbarHeight: breadCrumbHeight + 4 * margin + topbarHeight,
  appDrawerWidth: appDrawerWidth,
  appDrawerItemHeight: appDrawerItemHeight,
  totalAppDrawerWidth: appDrawerWidth + margin,
  // totalAppDrawerWithPageDrawer: appDrawerWidth + pageDrawerWidth + margin * 3,
  margin: margin,
  heightAppBar: topbarHeight,
  minimumPageWidth: minimumPageWidth,
  maximumPageWidth: maximumPageWidth,
  minimumPageHeight: minimumPageHeight,
  homeGridHeight: homeGridHeight,
};

export const getDimensions = () => dimensions;
